import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface BaseItemVibranceOptionProps {
  vibrance: number;
  updateVibrance(vibrance: number, undoable?: boolean): void;
}

export function BaseItemVibranceOption({...props}: BaseItemVibranceOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.updateVibrance(updatedValue, false);
  };

  const onChangeEndedHandler = (updatedValue: number): void => {
    props.updateVibrance(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-vibrance-option"
      value={props.vibrance}
      label={window.i18next.t('pmwjs_vibrance')}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
      range={{min: -1, max: 1}}
      transformDisplay={{min: 0, max: 100}}
    />
  );
}
